module.exports = __webpack_public_path__ + "static/media/plus-white.19683a4f.svg";